export const MedicalCertificateClassOptions = ['1st', '2nd', '3rd'];

export type MedicalCertificateClass =
  (typeof MedicalCertificateClassOptions)[number];
